<template>
  <div>
    <el-badge :is-dot="hasNotice">
      <i class="el-icon-bell" />
    </el-badge>
  </div>
</template>

<script>

export default {
  data() {
    return {
      hasNotice: false
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-badge__content.is-fixed.is-dot {
  right: 5px;
  top: 10px;
}

.el-icon-bell {
  font-size: 20px;
  cursor: pointer;
}
</style>
